import { useParams } from 'react-router';

import { useEffect, useState } from 'react';
import { stateKorea } from '../../utils/Languages';
import buskwarehousedetail from '../services/buskwarehousedetail';
import ReturnProductListHead from '../components/ReturnProductListHead';
import ReturnProductListTable from '../components/table/ReturnProductListTable';

const ReturnProduct = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const [returnProductCount, setReturnProductCount] = useState(0);
  const [returnProductRowData, setReturnProductRowData] = useState();
  const [selectedReturnProduct, setSelectedReturnProduct] = useState<
    React.Key[]
  >([]);

  const getReturnProduct = async (newPage: number) => {
    setLoading(true);
    const data = await buskwarehousedetail.getReturnProduct(id, newPage);
    const rowDataModified = data.data?.map((r: any) => {
      return {
        ...r,
        key: r.id,
        // no: index + (page - 1) * 10 + 1,
        no: r.id,
        state: stateKorea(r.state)
      };
    });
    setReturnProductRowData(rowDataModified);
    setReturnProductCount(data.count);
    setLoading(false);
  };

  useEffect(() => {
    getReturnProduct(page);
  }, [page]);

  return (
    <>
      <ReturnProductListHead
        totalReturnProduct={returnProductCount}
        selectedReturnProduct={selectedReturnProduct}
      />
      <ReturnProductListTable
        loading={loading}
        getData={getReturnProduct}
        totalItems={returnProductCount}
        returnProductRowData={returnProductRowData}
        selectedReturnProduct={selectedReturnProduct}
        setSelectedReturnProduct={setSelectedReturnProduct}
        onChangePage={setPage}
      />
    </>
  );
};

export default ReturnProduct;
